import 'Debug';
import Component from './Component';
import Events from './Events';
import Language from './Language';
import UI from './UI';
import API from './API';
import Auth from "./Auth";
import Form from "./Form";
import City from "./City";
import Geo from "./Geo";
import Storage from "./Storage";
import Player from "./Player";
import PriceManager from "./PriceManager";
import Panorama from "./Panorama";
import Place from "./Place";
import Map from "./Map";
import Tour from "./Tour";

export default class Core extends Component {

  _components = [
    new Events(this),
    new Language(this),
    new API(this),
    new UI(this),
    new Form(this),
    new Auth(this),
    new Storage(this),
    new Player(this),
    new PriceManager(this),
    new Map(this),
    new Panorama(this),
    new Geo(this),
    new City(this),
    new Place(this),
    new Tour(this),
  ];

  constructor() {
    super(...arguments);
    this.configure().run();
  }

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return this;
  }

  get components() {
    return this._components;
  }

  run() {
    this.logger('App is started');
  }

}